<nav
  class="mj-nav-bar"
  [class.mj-nav-bar--scrolled]="scrolled"
  aria-label="Navigation principale"
>
  <a
    [routerLink]="['/home']"
    fragment="manjocarn"
    class="mj-nav-bar__brand"
    (click)="closeMenu()"
  >
    <mat-icon class="mj-nav-bar__brand-icon">water</mat-icon>
    <span class="mj-nav-bar__brand-text">
      <span class="mj-nav-bar__brand-name">Manjocarn</span>
      <span class="mj-nav-bar__brand-baseline">· Guinguette</span>
    </span>
  </a>

  <div class="mj-nav-bar__links">
    <a
      *ngFor="let link of navLinks"
      [routerLink]="['/home']"
      [fragment]="link.id"
      class="mj-nav-bar__link"
      [class.active]="activeSection === link.id"
    >
      {{ link.label }}
    </a>
  </div>
</nav>

<nav class="mj-tab-bar" aria-label="Navigation mobile">
  <a
    *ngFor="let tab of bottomTabs"
    [routerLink]="['/home']"
    [fragment]="tab.id"
    class="mj-tab-bar__item"
    [class.active]="activeSection === tab.id"
    [attr.aria-current]="activeSection === tab.id ? 'page' : null"
    (click)="closeMenu()"
  >
    <span class="mj-tab-bar__icon"
      ><mat-icon>{{ tab.icon }}</mat-icon></span
    >
    <span>{{ tab.label }}</span>
  </a>
  <button
    type="button"
    class="mj-tab-bar__item mj-tab-bar__item--button"
    [class.active]="menuOpen || isMoreActive"
    [attr.aria-current]="!menuOpen && isMoreActive ? 'page' : null"
    [attr.aria-expanded]="menuOpen"
    aria-controls="mj-mobile-menu"
    aria-label="Plus de sections"
    (click)="toggleMenu()"
  >
    <span class="mj-tab-bar__icon"><mat-icon>more_horiz</mat-icon></span>
    <span>Plus</span>
  </button>
</nav>

<div class="mj-mobile-menu" id="mj-mobile-menu" [class.open]="menuOpen">
  <a
    *ngFor="let link of navLinks"
    [routerLink]="['/home']"
    [fragment]="link.id"
    class="mj-mobile-menu__link"
    [class.active]="activeSection === link.id"
    (click)="closeMenu()"
  >
    {{ link.label }}
  </a>
</div>

<section id="manjocarn" class="mj-section mj-hero">
  <div class="mj-hero__banner">
    <div class="mj-hero__overlay"></div>
    <div class="mj-hero__content">
      <p class="mj-surtitle">Guinguette</p>
      <h1 class="mj-hero__title">Manjocarn</h1>
      <p class="mj-tagline">Lieu atypique en pleine nature</p>
    </div>
  </div>
  <app-manjocarn appScrollReveal></app-manjocarn>
</section>

<section id="restaurant" class="mj-section mj-section--alt">
  <app-restaurant appScrollReveal></app-restaurant>
</section>

<section id="carte" class="mj-section">
  <app-carte appScrollReveal></app-carte>
</section>

<section id="evenements" class="mj-section mj-section--alt">
  <app-event appScrollReveal></app-event>
</section>

<section id="activites" class="mj-section">
  <app-activite appScrollReveal></app-activite>
</section>

<section id="payer" class="mj-section mj-section--alt">
  <app-payer appScrollReveal></app-payer>
</section>

<section id="instagram" class="mj-section">
  <app-instagram appScrollReveal></app-instagram>
</section>

<app-footer></app-footer>
